var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'has-background-dark': _vm.$themeDark,
    'has-text-light': _vm.$themeDark,
    'is-mobile': _vm.isMobile,
    'is-standalone': _vm.$isStandalone,
  },attrs:{"id":"app"}},[(_vm.websocketsAvailable === false)?_c('div',{staticClass:"tag is-warning real-time-updates"},[_vm._v(" Real Time Updates Unavailable ")]):_vm._e(),(_vm.maintenance && !_vm.hideMaintenanceSplash)?_c('MaintenanceSplash'):(_vm.updateRequired)?_c('UpdateRequiredSplash'):_vm._e(),_c('DefaultUI')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }